import Rest from '@/services/Rest'

export default class PatientConstraintService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/patientConstraints'

}
